import base64 from 'react-native-base64';
import { firebase } from '../config/configureFirebase';

// API endpoint test fonksiyonu
export const testGoogleAPIEndpoint = () => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify({
                    test: true,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    resolve(json);
                })
                .catch((error) => {
                    console.error('API endpoint test error:', error);
                    reject(error);
                });
        } catch (error) {
            console.error('API endpoint test global error:', error);
            reject(error);
        }
    });
};

export const fetchPlacesAutocomplete = (searchKeyword, sessionToken) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify({
                    searchKeyword: searchKeyword,
                    sessiontoken: sessionToken,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json && json.searchResults) {
                        resolve(json.searchResults);
                    } else {
                        reject(json.error || 'Invalid response format');
                    }
                })
                .catch((error) => {
                    console.error('fetchPlacesAutocomplete Fetch error:', error);
                    // Google API Error olarak reject etmek yerine daha detaylı hata mesajı
                    if (error.message && error.message.includes('REQUEST_DENIED')) {
                        reject(new Error('Google API Error: REQUEST_DENIED - API anahtarı veya izinler geçersiz'));
                    } else {
                        reject(new Error('fetchPlacesAutocomplete Call Error: ' + error.toString()));
                    }
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('fetchPlacesAutocomplete Global Error: ' + error.toString());
        }
    });
};

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify({
                    place_id: place_id,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json && json.coords) {
                        resolve(json.coords);
                    } else {
                        reject(json.error || 'Invalid response format');
                    }
                })
                .catch((error) => {
                    console.error('Fetch error:', error);
                    reject('fetchCoordsfromPlace Call Error: ' + error.toString());
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('fetchCoordsfromPlace Global Error: ' + error.toString());
        }
    });
};

export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify({
                    latlng: latlng,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json && json.address) {
                        resolve(json.address);
                    } else {
                        reject(json.error || 'Invalid response format');
                    }
                })
                .catch((error) => {
                    console.error('fetchAddressfromCoords Fetch error:', error);
                    // Google API Error olarak reject etmek yerine daha detaylı hata mesajı
                    if (error.message && error.message.includes('REQUEST_DENIED')) {
                        reject(new Error('Google API Error: REQUEST_DENIED - API anahtarı veya izinler geçersiz'));
                    } else {
                        reject(new Error('fetchAddressfromCoords Call Error: ' + error.toString()));
                    }
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('fetchAddressfromCoords Global Error: ' + error.toString());
        }
    });
};

export const searchAddress = (query) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId),
                },
                timeout: 10000,
                body: JSON.stringify({
                    query: query,
                    calltype: 'places',
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json && json.results) {
                        resolve(json.results);
                    } else {
                        reject(json.error || 'Invalid response format');
                    }
                })
                .catch((error) => {
                    console.error('searchAddress Fetch error:', error);
                    reject(new Error('searchAddress Call Error: ' + error.toString()));
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('searchAddress Global Error: ' + error.toString());
        }
    });
};

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify({
                    start: startLoc,
                    dest: destLoc,
                    calltype: 'matrix',
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json.error) {
                        console.error('API Error:', json.error);
                        reject(json.error);
                    } else if (!json || !json.hasOwnProperty('rows')) {
                        reject('Invalid response format');
                    } else {
                        resolve(json);
                    }
                })
                .catch((error) => {
                    console.error('Fetch error:', error);
                    reject('getDistanceMatrix Call Error: ' + error.toString());
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('getDistanceMatrix Global Error: ' + error.toString());
        }
    });
};

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve, reject) => {
        const { config } = firebase;
        try {
            const body = {
                start: startLoc,
                dest: destLoc,
                calltype: 'direction',
            };
            if (waypoints) {
                body['waypoints'] = waypoints;
            }

            fetch(`https://api.tasirimkurye.com/googleapi`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    Authorization: 'Basic ' + base64.encode(config.projectId ),
                },
                timeout: 10000,
                body: JSON.stringify(body),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (json.hasOwnProperty('distance_in_km')) {
                        resolve(json);
                    } else {
                        console.error('API Error:', json.error || 'Invalid response format');
                        reject(json.error || 'Invalid response format');
                    }
                })
                .catch((error) => {
                    console.error('Fetch error:', error);
                    reject('getDirectionsApi Call Error: ' + error.toString());
                });
        } catch (error) {
            console.error('Global error:', error);
            reject('getDirectionsApi Global Error: ' + error.toString());
        }
    });
};
